interface Props {
  size?: number;
}

// Huy hiệu ngôi sao của gói Premium: badge, menu và avatar dùng chung.
const PremiumStarIcon = ({ size = 16 }: Props) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="8" cy="8" r="7.1" fill="#1F1F1F" stroke="#D9A536" strokeWidth="1.3" />
    <path
      d="M8 3.9l1.29 2.62 2.89.42-2.09 2.04.49 2.88L8 10.5l-2.58 1.36.49-2.88L3.82 6.94l2.89-.42L8 3.9z"
      fill="#FFAC00"
    />
  </svg>
);

export default PremiumStarIcon;
